import { Address, Districes, Provinces, States } from "./models/RegisterModel";
import {
  FormRegister,
  SubmitResponse,
} from "../../screens/RegisterWolfScreen/RegisterModel";

export async function GetAllAddress(): Promise<Address> {
  const response = await fetch("api/CatalogMasterData/MasterData/Address", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((res) => res.json())
    .then((result) => result)
    .catch((err) => {
      console.error("GetProvince feiled: ", err);
    });

  console.log("response = ", response);

  return response;
}
export async function GetProvinceById(
  province: string
): Promise<Provinces | undefined> {
  const responseAddress: Address = await GetAllAddress();
  const response = responseAddress.Data.find((d) => d.Province === province);
  if (response) {
    return response;
  } else {
    return undefined;
  }
}
export async function GetDistriceById(
  districe: string
): Promise<Districes | undefined> {
  const responseAddress: Address = await GetAllAddress();
  const response = responseAddress.Data.flatMap((p) => p.Districes).find(
    (d) => d.Districe === districe
  );

  if (response) {
    return response;
  } else {
    return undefined;
  }
}
export async function GetStateById(state: string): Promise<States | undefined> {
  const responseAddress: Address = await GetAllAddress();
  const response = responseAddress.Data.flatMap((p) => p.Districes)
    .flatMap((d) => d.States)
    .find((s) => s.State === state);

  if (response) {
    return response;
  } else {
    return undefined;
  }
}

export const CheckBlackListForm = async (
  formData: FormRegister,
  supplier: string
): Promise<SubmitResponse> => {
  let response = await fetch(`api/Supplier/Register/${supplier}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((result) => {
      return result;
    });
  return response as SubmitResponse;
};

export const SaveUserToDatabase = async (
  formModel: any,
  supplierType: string
): Promise<BaseResponseDto> => {
  let response = await fetch(`api/Supplier/SaveUserSupplier/${supplierType}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formModel),
  })
    .then((response) => response.json())
    .then((result) => {
      return result;
    });
  return response as BaseResponseDto;
};
